<template>
  <div>
    <div class="relative inline-flex w-full items-center justify-center">
      <hr class="my-8 h-px w-64 border-0 bg-gray-200">
      <span
        class="absolute left-1/2 -translate-x-1/2 bg-white px-3 font-medium text-gray-900"
      >{{ pageTitle }}</span>
    </div>
    <a
      :href="routeLink"
      class="mt-2 flex w-full transform items-center justify-center rounded border border-main-primary/50 px-4 py-3 text-sm font-medium text-gray-700 shadow-sm hover:-translate-y-0.5 disabled:cursor-not-allowed disabled:border-gray-300 disabled:bg-disabled disabled:text-tertiary disabled:shadow-sm"
    >
      <MicrosoftIcon class="mr-2" />
      Microsoft
    </a>
  </div>
</template>

<script>
export default {
  name: 'LoginWithMicrosoft',

  props: {
    pageTitle: {
      type: String,
      required: true,
    },
  },

  computed: {
    routeLink() {
      const subdomainName = this.$store.companies.subdomain // Pass the value of the subdomain here or subdomain = ''
      const generateRandomString = (length) => {
        const characters
          = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
        let result = ''

        for (let i = 0; i < length; i++) {
          const randomIndex = Math.floor(Math.random() * characters.length)
          result += characters.charAt(randomIndex)
        }

        return result
      }
      const generateStateVariable = (subdomainName) => {
        // Generate random characters to be used in state to guard against CSRF protection as specified in
        // https://tools.ietf.org/html/rfc6749#section-10.12
        const randomString = generateRandomString(6)
        return subdomainName !== '' && subdomainName !== null
          ? `${randomString}-${subdomainName}`
          : randomString
      }
      const base_url = new URL(this.$config.public.microsoftOauth2LoginUrl)
      const params = new URLSearchParams(base_url.search);

      [
        { key: 'client_id', value: this.$config.public.microsoftClientId },
        {
          key: 'redirect_uri',
          value: `${this.$config.public.baseApi}v1/social/login/microsoft/callback/`,
        }, // Construct the URL
        { key: 'scope', value: 'User.Read' },
        { key: 'response_type', value: 'code' },
        { key: 'state', value: generateStateVariable(subdomainName) },
      ].forEach(({ key, value }) => params.set(key, value))

      return `${base_url.origin}${base_url.pathname}?${params.toString()}`
    },
  },
}
</script>
